// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"2a6cb72b","115":"332b7360","146":"18121e13","162":"f1682a0f","453":"5a07b7ce"}[chunkId] + ".chunk.js";
};